import { CircleX } from 'lucide-react';

import type { ErrorsT } from '@/pages/_main/manage/user/ManageUsersMassImportPage';

import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertDialog, AlertDialogBody, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/dialog';
import { FeaturedIcon } from '@/components/ui/featured-icon';

/**
 * Props for the UserMassImportError component.
 * @property {ErrorsT[]} errors - Array of error objects for failed imports.
 * @property {boolean} open - Whether the dialog is open.
 * @property {(value: boolean) => void} onOpenChange - Callback to change dialog open state.
 */
interface UserMassImportErrorProps {
  errors: ErrorsT[];
  open: boolean;
  onOpenChange: (value: boolean) => void;
}

export function UserMassImportError(userMassImportErrorProps: UserMassImportErrorProps) {
  const { errors, open, onOpenChange } = userMassImportErrorProps;
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className={'md:max-w-lg'}>
        <AlertDialogBody>
          <AlertDialogHeader className={'border-border-primary bg-card border-b'}>
            <FeaturedIcon size={'lg'}>
              <CircleX />
            </FeaturedIcon>
            <div className={'flex min-w-0 grow flex-col gap-0.5'}>
              <AlertDialogTitle>Wystąpił błąd podczas walidacji danych</AlertDialogTitle>
              <AlertDialogDescription className={'text-text-tertiary text-xs'}>Dane zostały wprowadzone niepoprawnie sprawdź i popraw je.</AlertDialogDescription>
            </div>
          </AlertDialogHeader>
          <div className={'flex flex-col gap-3 overflow-auto p-4'}>
            <div className={'flex flex-col gap-2'}>
              {errors.map(({ errors, data, index }, idx) => (
                <Alert key={idx}>
                  <AlertDescription className={'flex flex-col gap-2 overflow-hidden'}>
                    <h5 className={'text-sm font-medium'}>Indeks: {index + 1}</h5>
                    <p className={'w-full truncate text-sm'}>
                      {data.name}, {data.surname}, {data.email}, {data.phone}
                    </p>
                    <div>
                      {errors.map((error, idx) => (
                        <p key={idx} className={'text-fg-destructive text-xs'}>
                          *{error.message}
                        </p>
                      ))}
                    </div>
                  </AlertDescription>
                </Alert>
              ))}
            </div>
          </div>
        </AlertDialogBody>
        <AlertDialogFooter className={'border-border-primary dark:bg-card bg-accent border-t'}>
          <AlertDialogCancel variant={'tertiary'}>Zamknij</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
